import { render } from "./App.vue?vue&type=template&id=0616159d&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=0616159d&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=0616159d&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0616159d"]])

export default __exports__